













































import { Vue, Component } from 'vue-property-decorator';
import Form from '@/helpers/Form';
import AuthService, { ResetModel } from '@/services/core/AuthService';

@Component({})
export default class ResetPassword extends Vue
{
    private message: string = '';
    private messageVariant: string = 'danger';
    private form: Form<ResetModel> = Form.create<ResetModel>({
        email: '',
        newPassword: '',
        repeatPassword: ''
    });

    async onSubmit()
    {
        this.message = '';

        try
        {
            this.form.wait();

            let result = await AuthService.setPassword(
                this.$route.params.token,
                this.form.email,
                this.form.newPassword,
                this.form.repeatPassword
            );

            this.form.email = '';
            this.form.newPassword = '';
            this.form.repeatPassword = '';
            this.messageVariant = 'success';
            this.message = result;
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => { this.messageVariant = 'danger'; this.message = ex.message; },
                422: (ex: any) => this.form.$errors.record(ex.data.errors)
            });
        }
        finally
        {
            this.form.continue();
        }
    }
}
